import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=566d6989&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=566d6989&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566d6989",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('566d6989')) {
      api.createRecord('566d6989', component.options)
    } else {
      api.reload('566d6989', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=566d6989&scoped=true&", function () {
      api.rerender('566d6989', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4yC5S69HmQtDt/JS/comp/CookieBox.vue"
export default component.exports